import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      style={{
        marginTop: 'var(--space-12)',
        borderTop: '1px solid var(--line-1)',
        background: 'var(--bg-2)',
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 'var(--space-6)',
          padding: 'var(--space-8) var(--space-6)',
          fontSize: 'var(--fs-13)',
          color: 'var(--fg-3)',
        }}
      >
        <div style={{ flex: '0 0 280px' }}>
          <div style={{ fontWeight: 700, color: 'var(--fg-1)', marginBottom: 6 }}>tender-api</div>
          <div>
            Every EU procurement notice  -  TED + national portals + sub-threshold awards  -  as one
            normalised JSON feed. Operated by <a href="https://tender-api.com" style={{ color: 'var(--accent)' }}>openworld.fm</a>.
          </div>
        </div>
        <FooterCol heading="Product">
          <Link to="/sample">Live sample</Link>
          <Link to="/coverage">Coverage matrix</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/docs">Docs</Link>
        </FooterCol>
        <FooterCol heading="Company">
          <a href="https://tender-api.com">openworld.fm</a>
          <a href="mailto:support@tender-api.com">support@tender-api.com</a>
        </FooterCol>
        <FooterCol heading="Legal">
          <span style={{ fontSize: 'var(--fs-11)' }}>
            Data sourced from regulator-grade public registers under each
            jurisdiction's PSI / open-data licence. See per-country licence
            briefs in the docs.
          </span>
        </FooterCol>
      </div>
    </footer>
  );
}

function FooterCol({ heading, children }) {
  return (
    <div style={{ flex: '0 0 160px', display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--fs-11)',
          textTransform: 'uppercase',
          letterSpacing: 'var(--tracking-wider)',
          color: 'var(--fg-2)',
          marginBottom: 4,
        }}
      >
        {heading}
      </div>
      {children}
    </div>
  );
}
